import {DeletionModal, EditDeleteMoreButton} from '@hconnect/uikit/src/lib2'
import {TFunction} from 'i18next'
import React, {useState, useRef, useCallback} from 'react'

import {CommentEditDialog} from './CommentEditDialog'
import {CommonComment, EditCommentProps, DeleteCommentProps} from './comments.types'

interface CommentMoreButtonProps {
  comment: CommonComment
  moreButtonTestId?: string
  deleteCommentProps: DeleteCommentProps
  editCommentProps: EditCommentProps
  translate: TFunction
}

export const CommentMoreButton: React.FC<CommentMoreButtonProps> = ({
  comment,
  moreButtonTestId,
  deleteCommentProps,
  editCommentProps,
  translate
}) => {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)
  const [editDialogOpen, setEditDialogOpen] = useState(false)
  const commentToDelete = useRef<CommonComment>()

  const onDeleteClicked = useCallback((item: CommonComment) => {
    commentToDelete.current = item
    setDeleteDialogOpen(true)
  }, [])

  const onDeleteConfirmed = useCallback(() => {
    if (commentToDelete.current?.id) {
      deleteCommentProps.onDelete(commentToDelete.current.id)
    }
    setDeleteDialogOpen(false)
  }, [deleteCommentProps])

  const onDeleteCancelled = useCallback(() => {
    setDeleteDialogOpen(false)
    commentToDelete.current = undefined
  }, [])

  return (
    <>
      <EditDeleteMoreButton<CommonComment>
        loading={deleteCommentProps.deletingInProgress}
        item={comment}
        onEdit={() => {
          setEditDialogOpen(true)
        }}
        onDelete={onDeleteClicked}
        data-test-id={moreButtonTestId}
      />
      <DeletionModal
        open={deleteDialogOpen}
        message={translate('comments.deletionDialog.message')}
        cancelButtonCaption={translate('comments.action.cancel')}
        cancelButtonTestId={'comment-delete-cancel-btn'}
        confirmButtonTestId={'comment-delete-confirm-btn'}
        confirmButtonCaption={translate('comments.action.delete')}
        onConfirm={onDeleteConfirmed}
        onCancel={onDeleteCancelled}
      />
      <CommentEditDialog
        open={editDialogOpen}
        handleOpen={setEditDialogOpen}
        comment={comment}
        editCommentProps={editCommentProps}
        translate={translate}
      />
    </>
  )
}
